import axios from "axios";
import { encode } from "base-64";

const MasterApi = {
  getCustomers: async ({
    token,
    currentPage,
    projectPerPage,
    field,
    sort,
    search,
  }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/customer?currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${field}&sortType=${sort}${
        search ? `&search=${search}` : ""
      }`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProducts: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProductsOptionForSPK: async ({ token, category = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product-dropdown-spk?category=${category}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createMasterProduct: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/product`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateMasterProduct: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/product/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMasterProductDetail: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getById/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMasterProductChild: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getChild/${encode(id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMasterProductById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductSpecById: async ({ token, id }) => {
    const { data } = await axios
      .get(`${process.env.REACT_APP_BASE_URL}/product-spec/${encode(id)}`, {
        headers: {
          access_token: `${token}`,
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.product_spec_id,
          }));
        }
        return res;
      });

    return data.data;
  },

  createProductSpec: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/product-spec`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateProductSpec: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/product-spec/${encode(id)}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteProductSpec: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/product-spec/${encode(id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  verifyPin: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/users/verifypin`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getByRole: async ({
    token,
    outlet_id = "",
    role = "",
    url = "",
    search = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employeeDropdown?outlet_id=${encode(outlet_id)}&role=${role}&url=${url}&search=${search}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getCustomerById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/customer/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createCustomer: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/customer`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  editCustomer: async ({ token, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/customer/${payload.id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteCustomer: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/customer/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getCities: async ({ token, idProvinsi }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/city/${idProvinsi}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProvinces: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/province`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //MASTER DATA
  getMasterData: async ({ token, type }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/masterData/type/${type}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  productDropdown: async ({ token, params = {} }) => {
    const {
      isBarangPajak = "",
      isRequest = "",
      warehouse_id = "",
      outlet_id = "",
      category,
    } = params;
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product-dropdown-simple?isBarangPajak=${isBarangPajak}&isRequest=${isRequest}&warehouseId=${warehouse_id}&outlet_id=${outlet_id}&category=${category}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  assetDropdown: async ({ token, outletId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assetOption?outletId=${encode(outletId)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  productDropdownByWarehouse: async ({ token, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/config-warehouse-product/dropdown-product/${encode(warehouse_id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  productHaveParent: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getAllHaveParent`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductFastFoodOptions: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/waitressV3/isFastFood`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductByWarehouse: async ({ token, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getByStockWarehouse/${encode(
        warehouse_id,
      )}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByNip: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/getbyNip`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAssetByWarehouse: async ({ token, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assetOption-warehouse/${encode(
        warehouse_id,
      )}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllSupplier: async ({ token, productId = [], isBarangPajak = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/supplier_getSelectOption?is_barang_pajak=${isBarangPajak}`,
      {
        headers: {
          access_token: `${token}`,
          product_id: productId,
        },
      },
    );

    return data;
  },

  createMasterData: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/masterData`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateMasterData: async ({ token, payload, masterDataId = "" }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/masterData/${masterDataId}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteMasterData: async ({ token, masterDataId }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/masterData/${masterDataId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProductionBOM: async ({ token, params }) => {
    const {
      currentPage,
      perPage,
      sortBy,
      search = "",
      sortType,
      productId = "",
      categoryId = "",
      type = "",
      typePage = "",
    } = params;
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production-bom?search=${search}&currentPage=${currentPage}&pageSize=${perPage}&sort=${sortBy}&sortType=${sortType}&productId=${productId}&categoryId=${categoryId}&type=${type}&typePage=${typePage}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProductSpec: async ({ token }) => {
    const { data } = await axios
      .get(`${process.env.REACT_APP_BASE_URL}/product-spec`, {
        headers: {
          access_token: `${token}`,
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.product_spec_id,
          }));
        }
        return res;
      });

    return data.data;
  },

  getPoolOptions: async ({ token, outletId = "", status = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/pool-dropdown?outletId=${outletId}&status=${status}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getOutletOptions: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outlet/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllWarehouseNoPagination: async ({
    token,
    temporary,
    is_pic,
    is_retur,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/all?temporary=${temporary}&pic=${is_pic}&is_retur=${is_retur}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  getWarehouseByOutlet: async ({ token, outlet_id = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/getbyOutlet?outlet_id=${outlet_id ? encode(outlet_id) : ""}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByCategory: async ({ token, categoryId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse_getByCategory?category=${categoryId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByStock: async ({ token, productId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse_getByStock?product_id=${productId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByConfigWarehouse: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse_getByConfigWarehouse?product_id=${encode(id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  importProductWarehouse: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/warehouse/import`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getEmployees: async ({ token, params }) => {
    let {
      perPage,
      currentPage,
      outlet,
      division,
      sortBy,
      sortType,
      search,
      status,
      role,
      durationContract,
    } = params;
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/employee?statusPegawai=${status}&role=${encode(role)}&divisi=${encode(
        division,
      )}&outlet=${encode(
        outlet,
      )}&currentPage=${currentPage}&pageSize=${perPage}&sort=${sortBy}&sortType=${sortType}&search=${search}&durationContract=${durationContract}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteEmployee: async ({ token, nip }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/account/resign/${nip}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getRoles: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/role/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );
    return data;
  },

  getDivisions: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );
    return data;
  },

  getSubDivisions: async ({ token, divisionId, outletId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division-sub-dropdown?divisionId=${divisionId}&outletId=${outletId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getPositions: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/position/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );
    return data;
  },

  getEmployeeStatus: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employee_status`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );
    return data;
  },
  getBankOptions: async ({ token }) => {
    const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/bank`, {
      headers: {
        access_token: `${token}`,
      },
    });
    return data;
  },

  createEmployee: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/employee`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateEmployee: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/employee/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //   getEmployeeById: async ({ token, id }) => {
  //   const { data } = await axios.get(
  //     `${process.env.REACT_APP_BASE_URL}/employee-id/${id}`,
  //     {
  //       headers: {
  //         access_token: `${token}`,
  //       },
  //     }
  //   );
  //   return data;
  // },

  getEmployeeById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employee-id/${encode(id)}`,
      { headers: { access_token: token } },
    );
    return data;
  },

  getAllUnusedRackOption: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/all-unused-rack`,
      { headers: { access_token: token } },
    );
    return data;
  },

  getAllAccount: async ({ token, params }) => {
    let { perPage, currentPage, sortBy, sortType, search, type } = params;
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/account-coa?type=${type}&currentPage=${currentPage}&pageSize=${perPage}&sort=${sortBy}&sortType=${sortType}&search=${search}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllAccountOption: async ({ token, outletId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/all-account-coa?outletId=${outletId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data.data;
  },

  getAccountById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/account-coa/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data.data;
  },

  createAccount: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/account-coa`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateAccount: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/account-coa/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteAccount: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/account-coa/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createShift: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/shift`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  editShift: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/shift/${encode(id)}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteShift: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/shift/${encode(id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMasterShift: async ({
    token,
    search,
    currentPage,
    perPage,
    sortBy,
    sortType,
    outlet,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/shift?search=${search}&currentPage=${currentPage}&pageSize=${perPage}&sort=${sortBy}&sortType=${sortType}&outlet=${encode(outlet)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMasterShiftById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/shift/${encode(id)}}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getShiftOptions: async ({ token, outlet_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/shift-dropdown?outlet_id=${encode(outlet_id)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllRoom: async ({
    token,
    search = "",
    projectPerPage = 10,
    currentPage = 1,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/room/room?search=${search}&sort=name&sortType=asc&pageSize=${projectPerPage}&currentPage=${currentPage}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getRoomOption: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/room/room/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getTableByRoomCode: async ({ token, room_code }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/room/table/by_room_code/${room_code}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  importRoomTable: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/room/table/import`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMenu: async ({ token, role_id, outlet_id, employee_id = null }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/role/menu/${role_id}?outlet_id=${encode(outlet_id)}&employee_id=${employee_id ? encode(employee_id) : ""}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
};

export default MasterApi;
